import { FC } from 'react'

import { B2CTypeTable } from '@/types.ts'
import { useB2CState } from '@/stores/slices/b2c-slice'

import { B2CRequestsRegistriesTable } from './b2c-requests-registries-table.tsx'
import { B2CRequestsPaymentsTable } from './b2c-requests-payments-table.tsx'

export const B2CRequestTable: FC = () => {
  const { b2cType } = useB2CState()

  return b2cType === B2CTypeTable.REGISTRIES ? <B2CRequestsRegistriesTable /> : <B2CRequestsPaymentsTable />
}
